/** 
 * @TercioSantos-1 |
 * api/get/todas as configurações de 1 empresa |
 * api/get/1 configuração específica |
 * api/put/atualização de 1 configuração |
 */
import api from "../../services/api";

const CACHE_TTL_MS = 60 * 1000;
const settingsCache = new Map();

const getCacheKey = (type, payload) => `${type}:${JSON.stringify(payload || {})}`;

const getCached = (key) => {
    const cached = settingsCache.get(key);
    if (!cached) return null;

    if (Date.now() - cached.timestamp > CACHE_TTL_MS) {
        settingsCache.delete(key);
        return null;
    }

    return cached.data;
};

const setCached = (key, data) => {
    settingsCache.set(key, {
        data,
        timestamp: Date.now()
    });
};

const useCompanySettings = () => {

    const getAll = async (companyId) => {
        const cacheKey = getCacheKey("all", { companyId });
        const cached = getCached(cacheKey);
        if (cached) return cached;

        const { data } = await api.request({
            url: `/companySettings/${companyId}`,
            method: 'GET'
        });

        setCached(cacheKey, data);
        return data;
    }

   const get = async (params) => {
        const cacheKey = getCacheKey("one", params);
        const cached = getCached(cacheKey);
        if (cached) return cached;

        const { data } = await api.request({
            url: '/companySettingOne',
            method: 'GET',
            params
        });

        setCached(cacheKey, data);
        return data;
    } 

    const update = async (data) => {
        const { data: responseData } = await api.request({
            url: '/companySettings',
            method: 'PUT',
            data
        });
        settingsCache.clear();
        return responseData;
    }

    return {
        getAll,
        get,
        update
    }
}

export default useCompanySettings;
